var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},_vm._l((_vm.tabList),function(item){return _c('div',{key:item.id,staticClass:"tab-item",class:_vm.curTabId == item.id ? 'active' : '',on:{"click":function($event){return _vm.changeTab(item)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }